 query ExtractionTypes{
    extractionTypes {
    nodes {
      id
      extractionType
      isRawTextDocument
      isPdfDocument
      isImageDocument
    }
  }
 }

 